export enum SignUpCode {
  NAVER = "NAVER",
  GOOGLE = "GOOGLE",
  KAKAO = "KAKAO",
  APPLE = "APPLE",
  EMAIL = "EMAIL",
}
